/**
 * Checks if the content type matches the target type.
 * @param contentType The content type to check. Should not have wildcards.
 * @param targetType The target type, which can contain wildcards.
 */
export function contentTypeMatches(contentType: string, targetType: string): boolean {
  if (!contentType) return false;

  const [actualA, actualB] = contentType.toLowerCase().split('/');
  const [targetA, targetB] = targetType.toLowerCase().split('/');

  return (targetA === '*' || actualA === targetA)
    && (targetB === '*' || actualB === targetB);
}